<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>微信/支付宝充值</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">微信/支付宝充值</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <!-- <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入账号名称"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="用户名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name1"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="充值人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入充值人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="第三方支付号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.num"
                    placeholder="请输入第三方支付号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table
          ref="scrollTable"
          :data="tableData"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="充值金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.debitAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="充值类型" align="center">
            <template slot-scope="scope">{{
              scope.row.channelType == 3 ? "支付宝" : "微信"
            }}</template>
          </el-table-column>
          <el-table-column label="第三方支付号" align="center">
            <template slot-scope="scope">{{
              scope.row.thirdPaymentOrder
            }}</template>
          </el-table-column>
          <el-table-column label="平台支付号" align="center">
            <template slot-scope="scope">{{
              scope.row.tradeDetailNo
            }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作人名" align="center">
            <template slot-scope="scope">{{ scope.row.creatorName }}</template>
          </el-table-column> -->
          <el-table-column label="手机号" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.memberPhone }}</template>
          </el-table-column>
          <el-table-column label="用户名" align="center">
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="用户类型" align="center">
            <template slot-scope="scope">{{
              scope.row.memberTypeName
            }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="yellowColor" v-if="scope.row.status == 0"
                >待支付</span
              >
              <span class="greenColor" v-if="scope.row.status == 1"
                >已到账</span
              >
              <span class="redColor" v-if="scope.row.status == 2">已退款</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payAt"
            label="交易时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  确认充值
                </div>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="确认充值" :visible.sync="dialogFormVisible" width="400px">
      <div>充值账号</div>
      <div>
        <el-select
          v-model="value"
          filterable
          placeholder="请选择充值账号"
          style="width: 100%; margin: 20px 0"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="submitForm()" style="width: 100%"
        >确定</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      ruleForm: {
        name: "",
        name1: "",
        time: "",
        time1: "",
        num: "",
        phone: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      dialogFormVisible: false,
      value: "",
      options: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm() {
      this.$confirm("是否确认充值", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            companyId: val.memberId,
            id: val.id,
          };
          this.$axios
            .post(`/admapi/recharge/confirm`, param)
            .then(({ data }) => {
              this.$message({
                message: "确认成功",
                type: "success",
              });
            })
            .catch()
            .finally();
          this.dialogFormVisible = false;
        })
        .catch(() => {});
    },
    handleEdit(val) {
      this.dialogFormVisible = true;
    },
    handSuccess(res) {
      if (res.data.errorCount == 0) {
        this.$message({
          message: "导入成功",
          type: "success",
        });
      } else {
        let val = res.data.errorMessages.join(";");
        this.$message.error(val);
      }
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.name1 = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.ruleForm.num = "";
      this.ruleForm.phone = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name1 != "") {
        param.memberName = this.ruleForm.name1;
      }
      if (this.ruleForm.time != "") {
        param.startTime = this.ruleForm.time;
        param.endTime = this.ruleForm.time1;
      }
      if (this.ruleForm.phone != "") {
        param.phone = this.ruleForm.phone;
      }
      if (this.ruleForm.num != "") {
        param.thirdPaymentOrder = this.ruleForm.num;
      }
      this.$axios
        .post(`/admapi/recharge/paylist`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
